export enum AddPromoCodeCommissionFormFields {
  CommissionType = 'commissionType',
  CommissionValue = 'commissionValue',
  CommissionPercentage = 'commissionPercentage',
}
